import { WearableEligibilityCheckSteps } from '../typings';

// Need to remove this constant and logic related to this once Apple wearable journey go live successfully in production.
export const WEARABLE_DEVICE_BRANDS = ['Apple', 'Samsung'];

export const DEFAULT_WEARABLE_ELIGIBILITY_STEPS = [
  {
    id: 0,
    name: 'Account',
    value: WearableEligibilityCheckSteps.AccountSelection,
  },
  { id: 1, name: 'Line', value: WearableEligibilityCheckSteps.LineSelection },
];
